import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import {
  Alert,
  Card,
  Input,
  Checkbox,
  Button,
  IconButton,
  Typography,
} from "@material-tailwind/react";

import AgroTechnologyLogo from './agro-small.jpg';
import { FolderMinusIcon, ExclamationTriangleIcon,XMarkIcon } from '@heroicons/react/24/outline';

function PasswordRecoverCard(props) {

  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const [authenticated, setAuthenticated] = useState(localStorage.getItem("authenticated") || false);
  const [firstname, setFirstname] = useState(localStorage.getItem("firstname") || null);
  const [session, setSession] = useState(localStorage.getItem("session") || null);
  const [userid, setUserId] = useState(localStorage.getItem("userid") || 0);
  const [rank, setRank] = useState(localStorage.getItem("userid") || 0);

  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [statusMessage, setStatusMessage] = useState();
  const [alertColor, setAlertColor] = useState('red');
  const [buttonDisabled, setButtonDisabled] = useState(false);


  function handlePasswordRecovery(data) {
    
    console.log(data)
    if (data.status === "ok") {
        setMessage(data.message);
        setAlertColor('green');
        setAlert(true);
        const timer = setTimeout(() => {
            setAlert(false);
            props.close();
        }, 3000);
        return () => clearTimeout(timer);
    }
    if (data.status !== "ok") {
      setMessage(data.message);
      setAlert(true);
      const timer = setTimeout(() => {
        setButtonDisabled(false);    
        setAlert(false);
      }, 4000);
      return () => clearTimeout(timer);
    }

  }


  function cancelClose() {
    props.close();
  }


  function handleSubmit(e) {
    e.preventDefault();
    if (login)
        {
        setStatusMessage("Poczekaj chwilę ...");
        setButtonDisabled(true);  
        
        var bodydata = JSON.stringify({ action: 'recover', login: login });
        console.log(bodydata);
        fetch('https://online.mysoil.pl/cgi-bin/user.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'
        })
      .then(res => res.json())
      .then(data => handlePasswordRecovery(data))
    
    }
    else
        {
            console.log('no login');
            setStatusMessage("Wprowadź login lub email");
            return;
        }
  }

  return (
    <>
        <div className='fixed h-screen w-full top-0 left-0 m-0 items-center shadow-md justify-center flex bg-black/75'>
        <div className="p-1 bg-gradient-to-br from-teal-300 to-blue-300 rounded-2xl">
          <Card color="white" className="p-6 border-cyan-500 border-0" shadow={false}>
            <IconButton variant='text' size="sm" className='ml-auto mr-0 mt-0' color="blue-gray" data-refresh={false} onClick={props.close}>
                <XMarkIcon className='w-5 h-5' />
            </IconButton>

            <img src={AgroTechnologyLogo} alt="Agro-Technology" className="object-scale-down w-32 mx-auto mb-2" />

            <Typography color="gray" className="mt-4 font-normal mx-auto">
              Zapomniałeś hasła ? No cóż, zdarza się
            </Typography>
            <form className="mt-4 mb-2 w-64 max-w-screen-lg sm:w-80" onSubmit={handleSubmit}>
              <div className="mb-12 mt-8 flex flex-col gap-6 mx-[1rem]">
                <Input size="lg" label="Wprowadź swój login lub email" className="shadow-md" onChange={e => setLogin(e.target.value)} />
                <Typography color="gray" variant="small" className="relative -top-4 font-normal text-xs mx-auto text-red-700">
                {statusMessage}
                </Typography>
                
              </div>

              <div>
                <Button className="mx-auto flex w-[12rem] items-center mt-8 justify-center bg-gradient-to-br from-teal-500 to-cyan-500" fullWidth disabled={buttonDisabled} type="submit">
                  Wyślij
                </Button>
              </div>

            </form>
          </Card>
          </div>
      </div>
      <Alert open={alert}
        color={alertColor}
        onClose={() => setAlert(false)}
        variant="gradient" className='absolute top-8 right-8 w-96 shadow-lg z-[100]'
        animate={{ mount: { y: 0 }, unmount: { y: 100 }, }}>
        <span className='inline-flex'><ExclamationTriangleIcon className='w-6 mr-2 mt-0.5' />{message}</span>
      </Alert>

    </>
  );
}

export default PasswordRecoverCard;